module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "card card-square p2222"
  }, [_c('stars', {
    attrs: {
      "score": 5
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card card-square p2222 m2000"
  }, [_c('stars', {
    attrs: {
      "score": 2,
      "size": "sm",
      "enable": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card card-square p2222 m2000"
  }, [_c('stars', {
    attrs: {
      "score": 3,
      "size": "sm",
      "theme": "circle",
      "enable": false
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b013f0a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stars/demo.vue
// module id = 263
// module chunks = 27